import { Tutorial } from '@components/tutorial/Tutorial';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@stores';
import { Step } from 'react-joyride';

export function ChatTutorial() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Tutorial.Chat' });
  const { tab } = useAppStore();

  if (tab !== 'chat') return null;

  const steps: Step[] = [
    {
      target: '.chat-undefined',
      placement: 'center',
      content: t('chat0'),
    },
    {
      target: '.chat-undefined',
      placement: 'right',
      content: t('chat1'),
    },
    {
      target: '.chat-GLOBAL',
      placement: 'right',
      content: t('chat2'),
    },
    {
      target: '.chat-HELP',
      placement: 'right',
      content: (
        <>
          <p>{t('chat3_1')}</p>
          <p className="mt-2 text-gold">{t('chat3_2')}</p>
        </>
      ),
    },
    {
      target: '.whisper',
      placement: 'top',
      content: t('chat4'),
    },
    {
      target: '.whisper',
      placement: 'center',
      content: (
        <>
          <p className="mb-2 text-primary active">{t('chat5_1')}</p>
          <p>{t('chat5_2')}</p>
        </>
      ),
    },
  ];

  return <Tutorial tutorialKey="Chat" steps={steps} />;
}